export const managerPrices = {
  page: {
    title: "أسعار المنصة",
    subtitle: "قائمة أسعار خطط المنصة",
  },
  table: {
    name: "الاسم",
    type: "النوع",
    price: "السعر",
    created: "تاريخ الإنشاء",
    edit: "تعديل السعر",
  },
  form: {
    title: "تحديث السعر",
    planName: "اسم الخطة",
    planType: "نوع الخطة",
    annual: "سنوي",
    monthly: "شهري",
    cancel: "إلغاء",
    save: "حفظ",
  },
  toast: {
    saved: "تم الحفظ بنجاح",
    error: "خطأ في الطلب",
  },
};
